import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchCourses = () => api.get("/courses").then((r) => r.data.courses);
export const fetchTeachers = () => api.get("/teachers").then((r) => r.data.teachers);
export const fetchEvents = () => api.get("/events").then((r) => r.data.events);
export const fetchNews = () => api.get("/news").then((r) => r.data.news);
export const fetchNewsItem = (id) => api.get(`/news/${id}`).then((r) => r.data);
export const fetchGallery = () => api.get("/gallery").then((r) => r.data.gallery);
export const fetchProjects = () => api.get("/projects").then((r) => r.data.projects);
export const fetchProject = (id) => api.get(`/projects/${id}`).then((r) => r.data);
export const fetchMasterclass = () => api.get("/masterclass").then((r) => r.data.masterclass);
export const fetchReels = () => api.get("/reels").then((r) => r.data.reels);
export const fetchCrowdfunding = () => api.get("/crowdfunding").then((r) => r.data.crowdfunding);
export const fetchBlogComments = (newsId) => api.get(`/blog-comments/${newsId}`).then((r) => r.data.comments);
export const postBlogComment = (data) => api.post("/blog-comments", data).then((r) => r.data);

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitEnrollment = (data) => api.post("/enrollment", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const submitMemberApplication = (data) => api.post("/member-application", data).then((r) => r.data);
